/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignReviewValidationDataSchema = z.object({
	valid: z.boolean(),
	issues: z.array(z.object({ field: z.string(), message: z.string() })),
})

export type CampaignReviewValidationDataSchema = z.infer<typeof campaignReviewValidationDataSchema>
